/* ============================================================
   HAREEF — interactions & motion
   AOS scroll reveal · sticky add-to-cart · size chart · header state
   ============================================================ */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    /* ---------- Force-play hero background video (autoplay fallback) ---------- */
    (function () {
      var vids = document.querySelectorAll('.hh-bg video');
      vids.forEach(function (v) {
        v.muted = true; v.defaultMuted = true; v.setAttribute('playsinline', '');
        var tryPlay = function () { var p = v.play(); if (p && p.catch) p.catch(function () {}); };
        tryPlay();
        v.addEventListener('canplay', tryPlay, { once: true });
        document.addEventListener('touchstart', tryPlay, { once: true, passive: true });
        document.addEventListener('click', tryPlay, { once: true });
      });
    })();

    /* ---------- AOS scroll reveal ---------- */
    if (window.AOS) {
      AOS.init({
        duration: 750,
        easing: 'ease-out-quart',
        once: true,
        offset: 60,
        disable: function () { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
      });
    }

    /* ---------- Header: solid-ish on scroll ---------- */
    var header = document.querySelector('.header-wrapper');
    if (header) {
      var onScroll = function () {
        if (window.scrollY > 40) header.classList.add('hareef-scrolled');
        else header.classList.remove('hareef-scrolled');
      };
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    /* ---------- Header overlays: menu + search ---------- */
    (function () {
      // Portal panels to <body> so position:fixed is never trapped by the sticky
      // header's stacking/containing context (fixes transparent overlay + iOS quirks).
      document.querySelectorAll('[data-hh-panel]').forEach(function (p) {
        if (p.parentElement !== document.body) document.body.appendChild(p);
      });
      var lock = function (on) { document.documentElement.classList.toggle('hh-locked', on); };
      var panels = function () { return document.querySelectorAll('[data-hh-panel]'); };
      var open = function (name) {
        var p = document.querySelector('[data-hh-panel="' + name + '"]');
        if (!p) return;
        p.hidden = false;
        requestAnimationFrame(function () { p.classList.add('open'); });
        lock(true);
        if (name === 'search') {
          var inp = p.querySelector('[data-hh-search-input]');
          if (inp) setTimeout(function () { inp.focus(); }, 320);
        }
      };
      var closeAll = function () {
        panels().forEach(function (p) {
          p.classList.remove('open');
          setTimeout(function () { if (!p.classList.contains('open')) p.hidden = true; }, 480);
        });
        lock(false);
      };
      document.addEventListener('click', function (e) {
        var o = e.target.closest('[data-hh-open]');
        if (o) { e.preventDefault(); open(o.getAttribute('data-hh-open')); return; }
        if (e.target.closest('[data-hh-close]')) { e.preventDefault(); closeAll(); }
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
    })();

    /* ---------- Size chart modal ---------- */
    var sizeModal = document.getElementById('hareef-size-chart');
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-hareef-size-open]')) {
        e.preventDefault();
        if (sizeModal) { sizeModal.hidden = false; requestAnimationFrame(function(){ sizeModal.classList.add('open'); }); document.documentElement.style.overflow = 'hidden'; }
      }
      if (sizeModal && (e.target.closest('[data-hareef-size-close]') || e.target === sizeModal)) {
        sizeModal.classList.remove('open');
        document.documentElement.style.overflow = '';
        setTimeout(function () { sizeModal.hidden = true; }, 250);
      }
    });

    /* ---------- Product tabs ---------- */
    document.querySelectorAll('[data-hareef-tabs]').forEach(function (wrap) {
      var tabs = wrap.querySelectorAll('[data-tab]');
      var panes = wrap.querySelectorAll('[data-pane]');
      wrap.addEventListener('click', function (e) {
        var t = e.target.closest('[data-tab]');
        if (!t) return;
        var key = t.getAttribute('data-tab');
        tabs.forEach(function (x) { x.classList.toggle('active', x === t); });
        panes.forEach(function (p) { p.classList.toggle('active', p.getAttribute('data-pane') === key); });
      });
    });

    /* ---------- Remove "S" size option (client request) ---------- */
    (function () {
      var isS = function (v) { v = (v || '').trim().toLowerCase(); return v === 's' || v === 'small'; };
      // pill / swatch radios
      document.querySelectorAll('.product-form__input input[type="radio"], variant-selects input[type="radio"]').forEach(function (inp) {
        if (!isS(inp.value)) return;
        var label = inp.nextElementSibling;
        if (label && label.tagName === 'LABEL') label.style.display = 'none';
        inp.style.display = 'none';
        if (inp.checked) {
          var fs = inp.closest('fieldset') || inp.parentElement;
          var others = fs ? fs.querySelectorAll('input[type="radio"]') : [];
          for (var i = 0; i < others.length; i++) {
            if (!isS(others[i].value)) { others[i].checked = true; others[i].dispatchEvent(new Event('change', { bubbles: true })); break; }
          }
        }
      });
      // dropdown selects
      document.querySelectorAll('.product-form__input--dropdown select, variant-selects select').forEach(function (sel) {
        Array.prototype.slice.call(sel.options).forEach(function (opt) {
          if (isS(opt.value)) {
            var wasSel = opt.selected;
            opt.remove();
            if (wasSel && sel.options.length) { sel.selectedIndex = 0; sel.dispatchEvent(new Event('change', { bubbles: true })); }
          }
        });
      });
    })();

    /* ---------- Sticky add-to-cart bar ---------- */
    var sticky = document.getElementById('hareef-sticky-cart');
    var pdpForm = document.querySelector('.product-form__buttons');
    if (sticky && pdpForm) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) sticky.classList.remove('show');
          else if (en.boundingClientRect.top < 0) sticky.classList.add('show');
        });
      }, { threshold: 0 });
      io.observe(pdpForm);

      // sticky buttons proxy to the real ones
      sticky.querySelector('[data-sticky-add]') && sticky.querySelector('[data-sticky-add]').addEventListener('click', function () {
        var btn = document.getElementById(sticky.getAttribute('data-submit-id'));
        if (btn) btn.click();
      });
      sticky.querySelector('[data-sticky-buy]') && sticky.querySelector('[data-sticky-buy]').addEventListener('click', function () {
        var b = document.querySelector('[data-hareef-buynow]');
        if (b) b.click();
      });
    }
  });
})();
